import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import principle1 from "./principle-1";
import principle2 from "./principle-2";
import principle3 from "./principle-3";

const principle: Slide = {
  description:
    "This example shows room impulse responses (RIRs) for three different scenarios. For all of them, you are able to listen individually to the image source RIR or to the ray tracing RIR, or to the combination of both.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "top",
      controls: [
        {
          type: "button",
          items: [{ name: "Small office" }, { name: "Seminar room" }, { name: "Concert hall" }],
          options: {},
        },
      ],
      extraContent: [[]],
      components: [principle1, principle2, principle3],
    },
  },
};

export default principle;
